/**
 * web/styles.ts
 * Inject the shared stylesheet into `<head>` exactly once.
 *
 * The CSS payload lives in `./stylesCss` so this module stays focused
 * on the DOM-injection runtime (and both files stay under the
 * AGENTS.md 300-line file-length cap). Inline rather than a static
 * `.css` file so Vite ships one bundle and Jest doesn't need a CSS
 * loader.
 *
 * @module web/styles
 */

/// <reference lib="dom" />

import { SHARED_CSS } from './stylesCss';

let _injected = false;

/**
 * Inject the shared stylesheet into `<head>` exactly once.
 * Subsequent calls are no-ops so screen modules can call freely.
 */
export function injectStyles(): void {
  if (_injected) return;
  const doc = globalThis.document;
  if (!doc) return;
  const style = doc.createElement('style');
  style.dataset['sfStyles'] = 'shared';
  style.textContent = SHARED_CSS;
  doc.head.append(style);
  _injected = true;
}

/** Test-only — clear the inject guard so tests can re-mount. */
export function _resetStylesForTesting(): void {
  _injected = false;
  const doc = globalThis.document;
  if (!doc) return;
  doc.querySelectorAll('style[data-sf-styles="shared"]').forEach((n) => n.remove());
}
